module.exports = __webpack_public_path__ + "img/info-02.2726fdb1.jpg";